import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { NewsBare, NewsCreate } from 'SharedDir/declarations/news';
import { Paginated } from 'SharedDir/declarations/pagination';
import { PUBLIC_NEWS, publicNewUrl } from 'SharedDir/backend/endpoints/public-news';

export default class PublicNewsApiClass extends SimpleApi<NewsBare, NewsCreate> {
  constructor() {
    super(publicNewUrl);
  }

  // public async getPublic<T>(id: number, params?: T) {
  //   const { data } = (await http({
  //     ...PUBLIC_NEWS.GET(id),
  //     params,
  //   })) as AxiosResponse<Paginated<NewsBare, any>>;
  //   return data;
  // }
}
